export const appName = 'tdopro';
export const version = '1.9.64';
